import todayJson from './data/today.json';

const today = (state = todayJson) => {
    return(state);
};

export default today;
